export default import.meta.ROLLUP_FILE_URL_5zuGM$AAtQ3alzTerYHiVA